import React, { useEffect, Component } from 'react';
import { ChevronRight, Phone, Shield, Cookie, Users, Lock, Mail } from 'lucide-react';
const sections = [{
  icon: Shield,
  title: 'Switchplate Gallery Privacy Policy',
  content: `Thank you for visiting our web site. This privacy policy tells you how we use personal information collected at this site. By using the site, you are accepting the practices described in this privacy policy. These practices may be changed, but any changes will be posted and changes will only apply to activities and information on a going forward, not retroactive basis. You are encouraged to review this policy whenever you visit the site to make sure that you understand how any personal information you provide will be used.`
}, {
  icon: Users,
  title: 'What Information Do We Collect',
  content: `We collect personally identifiable information, like names, addresses, email addresses, credit/debit card numbers, etc., that is voluntarily submitted by our customers. The information you provide is used to fulfill and pay for your specific order, unless you give us permission to use it in another manner, such as requesting your name being added to one of our mailing lists.`
}, {
  icon: Cookie,
  title: 'Cookie/Tracking Technology',
  content: `The Site may use cookie and tracking technology depending on the features offered. Cookie and tracking technology are useful for gathering information such as browser type and operating system, tracking the number of visitors to our website, and understanding how visitors use our website.`
}, {
  icon: Users,
  title: 'Distribution of Information',
  content: `Your information is not released to any other agency or business for any reason other than legal actions.`
}, {
  icon: Lock,
  title: 'Commitment to Data Security',
  content: `All of your personal information is kept secure. Only authorized employees have access to this information. All emails and newsletters from this site allow you to opt out of further mailings.`
}];
export function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream" data-id="element-771">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-772">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-773">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-774">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-775">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-776" />
            <a href="#/support" className="hover:text-gold transition-colors" data-id="element-777">
              Support
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-778" />
            <span className="text-charcoal font-medium" data-id="element-779">Privacy Policy</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-780">
            Privacy Policy
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-781">
        <div className="space-y-8" data-id="element-782">
          {sections.map((section, idx) => {
          const IconComponent = section.icon;
          return <div key={idx} className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-783">
                <div className="flex items-center gap-3 mb-5" data-id="element-784">
                  <div className="w-10 h-10 bg-gold/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-785">
                    <IconComponent className="w-5 h-5 text-gold" data-id="element-786" />
                  </div>
                  <h2 className="text-xl font-serif text-charcoal" data-id="element-787">
                    {section.title}
                  </h2>
                </div>
                <p className="text-warmGray leading-relaxed" data-id="element-788">
                  {section.content}
                </p>
              </div>;
        })}

          {/* Privacy Contact */}
          <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-789">
            <div className="flex items-center gap-3 mb-5" data-id="element-790">
              <div className="w-10 h-10 bg-gold/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-791">
                <Mail className="w-5 h-5 text-gold" data-id="element-792" />
              </div>
              <h2 className="text-xl font-serif text-charcoal" data-id="element-793">
                Privacy Contact Information
              </h2>
            </div>
            <p className="text-warmGray leading-relaxed mb-6" data-id="element-794">
              If you have any questions, concerns, or comments about our privacy
              policy you may contact us using the information below:
            </p>
            <a href="tel:13046863170" className="inline-flex items-center gap-2 text-xl font-serif text-gold hover:text-gold-dark transition-colors" data-id="element-795">
              <Phone size={18} data-id="element-796" />
              1-304-686-3170
            </a>
          </div>

          {/* Policy Changes Notice */}
          <div className="bg-cream-dark p-6 rounded-sm border border-warmBorder text-center" data-id="element-797">
            <p className="text-warmGray text-sm leading-relaxed" data-id="element-798">
              We reserve the right to make changes to this policy. Any changes
              to this policy will be posted.
            </p>
          </div>
        </div>
      </div>
    </section>;
}